﻿class AnimatedRotatingText extends HTMLElement {
    private words: string[] = [];
    private currentIndex = 0;
    private intervalId?: number;
    private textSpan!: HTMLSpanElement;

    connectedCallback() {
        // Read attributes
        const wordsAttr = this.getAttribute("words");
        if (wordsAttr) {
            this.words = wordsAttr.split(",").map(w => w.trim());
        }

        const containerClass = this.getAttribute("data-class") ?? "text-[#00d9b8] font-semibold text-lg sm:text-xl lg:text-2xl";
        const spanClass = this.getAttribute("data-span-class") ?? "inline-block transition-all duration-500 opacity-100 translate-y-0";
        const spanTransitionClass = this.getAttribute("data-span-transition-class") ?? "inline-block transition-all duration-500 opacity-0 -translate-y-4";

        this.className = `inline-block ${containerClass}`;
        this.textSpan = document.createElement("span");
        this.textSpan.className = spanClass;
        this.textSpan.textContent = this.words[0] ?? "";
        this.appendChild(this.textSpan);

        this.intervalId = window.setInterval(() => {
            this.textSpan.className = spanTransitionClass;

            setTimeout(() => {
                this.currentIndex = (this.currentIndex + 1) % this.words.length;
                this.textSpan.textContent = this.words[this.currentIndex];
                this.textSpan.className = spanClass;
            }, 500);
        }, 2000);
    }

    disconnectedCallback() {
        if (this.intervalId) clearInterval(this.intervalId);
    }
}

customElements.define("animated-rotating-text", AnimatedRotatingText);

document
    .querySelector("animated-rotating-text")
    ?.addEventListener("click", () => {
        console.log("Rotating text clicked!");
    });
